import { combineReducers } from 'redux-immutable';

import ActiveTeamReducer from './ActiveTeamReducer/ActiveTeamReducer';
import { BaseActiveTeamStore } from './ActiveTeamReducer/ActiveTeamReducer.types';
import DataTeamReducer from './DataTeamReducer/DataTeamReducer';
import { BaseDataTeamStore } from './DataTeamReducer/DataTeamReducer.types';
import TeamOptionsReducer from './TeamOptionsReducer/TeamOptionsReducer';
import { BaseTeamOptionsStore } from './TeamOptionsReducer/TeamOptionsReducer.types';

export interface BaseTeamStoreElement {
  data: BaseDataTeamStore;
  activeTeam: BaseActiveTeamStore;
  teamOptions: BaseTeamOptionsStore;
}

export const TeamReducer = combineReducers<BaseTeamStoreElement>({
  data: DataTeamReducer,
  activeTeam: ActiveTeamReducer,
  teamOptions: TeamOptionsReducer,
});

export interface BaseTeamStore {
  team: BaseTeamStoreElement;
}
